(function() {
	var euro = String.fromCharCode(8364);
	var reTest = new RegExp(euro + '\\s*[\\d]');
	var reReplace = new RegExp(euro + '\\s*([\\d\\s.,]+)', 'g');

	function reformatPriceNodes(root) {
		var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null, false);
		var nodes = [];
		var node;
		while ((node = walker.nextNode())) {
			if (reTest.test(node.nodeValue)) nodes.push(node);
		}
		nodes.forEach(function(n) {
			n.nodeValue = n.nodeValue.replace(reReplace, function(_, amount) {
				return amount.trim() + ' ' + euro;
			});
		});
	}

	function init() {
		reformatPriceNodes(document.body);
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				mutation.addedNodes.forEach(function(addedNode) {
					if (addedNode.nodeType === 1) reformatPriceNodes(addedNode);
				});
			});
		});
		observer.observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
